export default __webpack_public_path__ + "static/media/spinach.c2100d5b.jpg";